// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PhoneHover: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 8 12"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="8"
            height="12"
            fill="currentColor"
        >
            <path
                d="M1230.375,626 C1230.99632,626 1231.5,626.50368 1231.5,627.125 L1231.5,636.875 C1231.5,637.49632 1230.99632,638 1230.375,638 L1225.125,638 C1224.50368,638 1224,637.49632 1224,636.875 L1224,627.125 C1224,626.50368 1224.50368,626 1225.125,626 L1230.375,626 Z M1230.375,626.75 L1225.125,626.75 C1224.91789,626.75 1224.75,626.917893 1224.75,627.125 L1224.75,636.875 C1224.75,637.082107 1224.91789,637.25 1225.125,637.25 L1230.375,637.25 C1230.58211,637.25 1230.75,637.082107 1230.75,636.875 L1230.75,627.125 C1230.75,626.917893 1230.58211,626.75 1230.375,626.75 Z M1227.75,635.747826 C1227.84999,635.747826 1227.94584,635.787758 1228.01625,635.85875 C1228.04937,635.8952 1228.07601,635.937056 1228.095,635.9825 C1228.11422,636.027583 1228.12441,636.075996 1228.125,636.125 C1228.12684,636.149966 1228.12684,636.175034 1228.125,636.2 C1228.1209,636.223493 1228.11331,636.246243 1228.1025,636.2675 C1228.09429,636.291397 1228.08294,636.314096 1228.06875,636.335 L1228.02375,636.39125 C1227.95115,636.463321 1227.85226,636.502606 1227.75,636.5 C1227.54289,636.5 1227.375,636.332107 1227.375,636.125 C1227.37559,636.075996 1227.38578,636.027583 1227.405,635.9825 C1227.42399,635.937056 1227.45063,635.8952 1227.48375,635.85875 C1227.55416,635.787758 1227.65001,635.747826 1227.75,635.747826 Z"
                transform="translate(-1224 -626)"
            />
        </svg>
    );
};

export default React.memo(PhoneHover);
